import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent } from '@fuse';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Input, Select as MSelect, Radio, MenuItem,Toolbar, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText,AppBar } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import CloseIcon from '@material-ui/icons/Close';
import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import ItemAdder from "main/content/sales/billing/itemAdder";
import { withAlert } from 'react-alert';

import Select from 'react-select';
import moment from 'moment';
import 'react-select/dist/react-select.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import { Icon, IconButton } from 'material-ui';



const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0,
        width: "100%",
        textAlign: "right",
        fontSize: '1.8rem'
    }
});

class BankReconsilation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            bankLedgerAccountIds: [],
            accountNameOptions: [],
            accountRefOptions: [],
            ledgerAccounts: [],
            ledgerAccountName: '',
            ledgerAccountRefNo: '',
            ledgerAccountNames: [],
            ledgerAccountRefs: [],
            bankTransactionsDebitOriginal: [],
            bankTransactionsCreditOriginal: [],
            bankTransactionsDebit: [],
            bankTransactionsCredit: [],
            bankLedgerAccount: '',
            bankName: '',
            statementBalance: 0.00,
            date: moment(new Date()).format("YYYY-MM-DD"),
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),
            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            documentNumber: '',
            openAddNewTransaction: false,
            addNewTransactionType: 'deposit'
        };

        this.getCheckBoxValueCredit = this.getCheckBoxValueCredit.bind(this);
        this.getCheckBoxValueDebit = this.getCheckBoxValueDebit.bind(this);
        this.handleAddNewTransactionClose = this.handleAddNewTransactionClose.bind(this);
        this.handleFloatTextBoxChange = this.handleFloatTextBoxChange.bind(this);
        this.handleBankChange = this.handleBankChange.bind(this);
        this.handleBankLedgerAccountChange = this.handleBankLedgerAccountChange.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.populateData();
    }



    populateData() {
        this.getBankLedgerAccounts();
        //this.getChequeDataAndLedgerAccounts();
    }

    getLedgerAccounts() {
        console.log('getting ledger accounts...');

        this.setState({ loading: true });
        const request = axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails');
        request.then((response) => {


            if (!response.data.error && response.data.success && response.data.ledgerAccountDetails) {
                console.log('ledger accounts recieved', response.data);
                var ledgerAccounts = [];
                var ledgerAccountNames = [];
                var ledgerAccountRefs = [];
                for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {
                    ledgerAccounts.push(
                        {
                            ID_LEDGER_ACCOUNT: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            NAME: response.data.ledgerAccountDetails[i].NAME,
                            LEDGER_REF_NO: response.data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                    ledgerAccountNames.push(
                        {
                            value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: response.data.ledgerAccountDetails[i].NAME
                        }
                    );
                    ledgerAccountRefs.push(
                        {
                            value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: response.data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                }
                this.setState(
                    {
                        ledgerAccounts: ledgerAccounts,
                        ledgerAccountNames: ledgerAccountNames,
                        ledgerAccountRefs: ledgerAccountRefs
                    }
                );

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('error', error);
                this.setState({ loading: false });
            });
    }

    getBankLedgerAccounts() {
        console.log('getting bank ledger accounts...');

        this.setState({ loading: true });

        const request4 = axios.get(window.accountServer + '/bank/getLedgerAccountsOfBanks');

        request4.then((response) => {

            var accountNameOptions = [];
            var accountRefOptions = [];

            if (!response.data.error && response.data.success) {
                console.log('bank ledger accounts recieved', response.data);

                var bankList = [];
                for (var key in response.data.LedgerAccountsOfBanks) {
                    if (response.data.LedgerAccountsOfBanks.hasOwnProperty(key)) {
                        bankList.push({ value: key, label: key });
                    }
                }

                this.setState({
                    loading: false,
                    bankList: bankList,
                    ledgerAccountsOfBanks: response.data.LedgerAccountsOfBanks
                });
            }
            else {
                console.log('error', response.data);
                this.setState({ loading: false });
            }
        })
            .catch((error) => {
                console.log('error', error);
                this.setState({ loading: false });
            });
    }

    getChequeDataAndLedgerAccounts(bankLedgerId, fromDate, toDate) {
        console.log('getting cheque data...');

        this.setState({ loading: true });

        let promises = [];

        var reqBody = {
            bankLedgerId: bankLedgerId,
            fromDate: fromDate,
            toDate: toDate
        };
        const request = axios.post(window.accountServer + '/payMode/getChequePayments', reqBody);
        promises.push(request);

        var reqBody2 = {
            bankLedgerId: bankLedgerId,
            fromDate: fromDate,
            toDate: toDate
        };
        const request2 = axios.post(window.accountServer + '/deposit/getChequeDeposits', reqBody2);
        promises.push(request2);

        const request3 = axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails');
        promises.push(request3);

        const request4 = axios.get(window.accountServer + '/bank/getLedgerAccountsOfBanks');
        promises.push(request4);

        axios.all(promises)
            .then(axios.spread((...args) => {
                console.log('args[0]', args[0]);
                console.log('args[1]', args[1]);
                console.log('args[2]', args[2]);

                var a1 = args[0];
                var a2 = args[1];
                if (!a1.data.success || !a1.data.success) {
                    return this.props.alert.error('Bank Records Response Error');
                }

                if (!args[2].data.success || !args[2].data.ledgerAccountDetails) {
                    return this.props.alert.error('Ledger Accounts Response Error');
                }

                for (let i = 0; i < a1.data.chequePayments.length; i++) {
                    if (a1.data.chequePayments[i].IS_CHEQUE_NOT_PRESENT == 1) {
                        a1.data.chequePayments[i].state = 'not present';
                    } else if (a1.data.chequePayments[i].IS_CHEQUE_NOT_PRESENT == 0) {
                        a1.data.chequePayments[i].state = 'realized';
                    } else if (a1.data.chequePayments[i].IS_CHEQUE_NOT_PRESENT == -1) {
                        a1.data.chequePayments[i].state = 'return';
                    }
                }

                for (let i = 0; i < a2.data.chequeDeposits.length; i++) {
                    if (a2.data.chequeDeposits[i].IS_CHEQUE_NOT_PRESENT == 1) {
                        a2.data.chequeDeposits[i].state = 'not present';
                    } else if (a2.data.chequeDeposits[i].IS_CHEQUE_NOT_PRESENT == 0) {
                        a2.data.chequeDeposits[i].state = 'realized';
                    } else if (a2.data.chequeDeposits[i].IS_CHEQUE_NOT_PRESENT == -1) {
                        a2.data.chequeDeposits[i].state = 'return';
                    }
                }

                var ledgerAccounts = [];
                var ledgerAccountNames = [];
                var ledgerAccountRefs = [];
                for (let i = 0; i < args[2].data.ledgerAccountDetails.length; i++) {
                    ledgerAccounts.push(
                        {
                            ID_LEDGER_ACCOUNT: args[2].data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            NAME: args[2].data.ledgerAccountDetails[i].NAME,
                            LEDGER_REF_NO: args[2].data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                    ledgerAccountNames.push(
                        {
                            value: args[2].data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: args[2].data.ledgerAccountDetails[i].NAME
                        }
                    );
                    ledgerAccountRefs.push(
                        {
                            value: args[2].data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                            label: args[2].data.ledgerAccountDetails[i].LEDGER_REF_NO
                        }
                    );
                }




                this.setState(
                    {
                        ledgerAccounts: ledgerAccounts,
                        ledgerAccountNames: ledgerAccountNames,
                        ledgerAccountRefs: ledgerAccountRefs,
                    }
                );

                this.setState({
                    bankTransactionsCredit: [...a1.data.chequePayments],
                    bankTransactionsDebit: [...a2.data.chequeDeposits],
                    // bankTransactionsCreditOriginal : [...a1.data.chequePayments],
                    // bankTransactionsDebitOriginal : [...a2.data.chequeDeposits],
                });

                this.props.alert.success('Bank Records Retrieved');
                this.setState({ loading: false });
            }))
            .catch((error) => {
                console.log('axios all error', error);
                this.props.alert.error('Bank Records Retrieve Failed');
            });
    }

    getBankLedgersByBank() {
        if (!this.state.ledgerAccountsOfBanks || this.state.bankName == '' || !this.state.ledgerAccountsOfBanks[this.state.bankName]) {
            return [];
        }
        const ledgerOfBank = this.state.ledgerAccountsOfBanks[this.state.bankName];
        const ledgersOptions = ledgerOfBank.map(function (item) {
            return {
                value: item.ID_LEDGER_ACCOUNT,
                label: item.LEDGER_REF_NO
            }
        })
        return ledgersOptions;
    }

    handleSearchClick() {
        console.log('fromDate', this.state.fromDate);
        if (this.state.fromDate == '' || this.state.toDate == '') {
            return this.props.alert.error('Select Dates');
        }
        if (this.state.bankLedgerAccount == '') {
            return this.props.alert.error('Select Ledger Account');
        }

        this.getChequeDataAndLedgerAccounts(this.state.bankLedgerAccount, this.state.fromDate, this.state.toDate);

    }

    handleBankChange(selectedOption) {
        if (selectedOption) {
            this.setState({ bankName: selectedOption.value, bankLedgerAccount: '' });
        }
        else {
            this.setState({ bankName: '', bankLedgerAccount: '' });
        }
    }

    handleBankLedgerAccountChange(selectedOption) {
        if (selectedOption) {
            this.setState({ bankLedgerAccount: selectedOption.value });
        }
        else {
            this.setState({ bankLedgerAccount: '' });
        }
    }

    handleCheckBoxChangeDebit = (name, prop) => event => {
        console.log('handleCheckBoxChange name', name);

        let bankTransactionsDebit = [...this.state.bankTransactionsDebit];
        for (let i = 0; i < bankTransactionsDebit.length; i++) {
            if (String(bankTransactionsDebit[i].ID_DIPOSIT_DETAIL_HEADER) == String(name)) {
                if (bankTransactionsDebit[i].state == prop) {
                    bankTransactionsDebit[i].state = '';
                }
                else {
                    bankTransactionsDebit[i].state = prop;
                }

                break;
            }
        }
        this.setState({ bankTransactionsDebit: bankTransactionsDebit });
    };

    getCheckBoxValueDebit = (id, prop) => {
        let checkValues = this.state.bankTransactionsDebit.filter(record =>
            String(record.ID_DIPOSIT_DETAIL_HEADER) === String(id)
        );
        //console.log('filtered value', checkValues);
        if (checkValues && checkValues.length > 0 && String(checkValues[0].state) == String(prop)) {
            return true;
        }
        else {
            return false;
        }
    };

    handleCheckBoxChangeCredit = (name, prop) => event => {
        //console.log('handleCheckBoxChange name', name);

        let bankTransactionsCredit = [...this.state.bankTransactionsCredit];
        for (let i = 0; i < bankTransactionsCredit.length; i++) {
            if (String(bankTransactionsCredit[i].ID_PAYMENT_MODE) == String(name)) {
                if (bankTransactionsCredit[i].state == prop) {
                    bankTransactionsCredit[i].state = '';
                }
                else {
                    bankTransactionsCredit[i].state = prop;
                }

                break;
            }
        }
        this.setState({ bankTransactionsCredit: bankTransactionsCredit });
    };

    getCheckBoxValueCredit = (id, prop) => {
        let checkValues = this.state.bankTransactionsCredit.filter(record =>
            String(record.ID_PAYMENT_MODE) === String(id)
        );
        //console.log('filtered value', checkValues);
        if (checkValues && checkValues.length > 0 && String(checkValues[0].state) == String(prop)) {
            return true;
        }
        else {
            return false;
        }
    };

    getTotalOfTransactionsCredit(type) {
        // console.log('getTotalOfTransactions',type);
        var bankTransaction = this.state.bankTransactionsCredit;
        if (bankTransaction && bankTransaction.length > 0) {
            //console.log('getTotalOfTransactions bankTransactionsCredit.length>0 ',bankTransaction.length);
            let typeValues = bankTransaction.filter(record =>
                String(record.state) == String(type)
            );
            //console.log('typeValues',typeValues);
            if (typeValues.length > 0) {
                var total = 0.00;
                for (let i = 0; i < typeValues.length; i++) {
                    let newVal = typeValues[i].CR;
                    total = parseFloat(total) + parseFloat(newVal);
                }
                console.log('total', total);
                return parseFloat(total).toFixed(2);
            }
            else {
                return 0.00;
            }
        }
        else {
            return 0.00;
        }
    }

    getTotalOfTransactionsDebit(type) {
        //console.log('getTotalOfTransactions',type);
        var bankTransaction = this.state.bankTransactionsDebit;
        if (bankTransaction.length > 0) {
            //console.log('getTotalOfTransactions bankTransactionsDebit.length>0 ',bankTransaction.length);
            let typeValues = bankTransaction.filter(record =>
                String(record.state) == String(type)
            );
            //console.log('typeValues',typeValues);
            if (typeValues.length > 0) {
                var total = 0.00;
                for (let i = 0; i < typeValues.length; i++) {
                    let newVal = typeValues[i].AMOUNT;
                    total = parseFloat(total) + parseFloat(newVal);
                }
                console.log('total', total);
                return parseFloat(total).toFixed(2);
            }
            else {
                return 0.00;
            }
        }
        else {
            return 0.00;
        }
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleFloatTextBoxChange = prop => event => {
        var value = event.target.value;
        console.log('handleFloatTextBoxChange value', value);
        console.log('handleFloatTextBoxChange prop', prop);
        value = !isNaN(value) ? value : this.state[prop];
        this.setState(
            { [prop]: value }
        );
    };

    handleAddNewTransactionSave() {
        if (!this.state.addNewTransactionAmount || this.state.addNewTransactionAmount == '') {
            return this.props.alert.error('Insert Amount');
        }
        if (this.state.ledgerAccountRefNo == '') {
            return this.props.alert.error('Select Ledger Account');
        }
        /* if (!this.state.addNewTrasnsactionChequeNumber || this.state.addNewTrasnsactionChequeNumber.length > 6) {
            return this.props.alert.error('Invalid Cheque Number');
        } */
        if (this.state.addNewTransactionType == 'deposit') {
            let bankTransactionsDebit = [...this.state.bankTransactionsDebit];
            let newTransaction = {
                //CHEQUE_NO: this.state.addNewTrasnsactionChequeNumber,
                AMOUNT: this.state.addNewTransactionAmount,
                IS_CHEQUE_NOT_PRESENT: 0,
                state: 'realized',
                isNewTransaction: true,
                newTransactionInfo: {
                    ledgerAccountId: this.state.ledgerAccountName,
                    transactionDate: this.state.addNewTransactionDate,
                    transactionNo: this.state.addNewTransactionTransactionNo,
                    description: this.state.addNewTransactionDescription,
                }
            };
            bankTransactionsDebit.push(newTransaction);
            this.setState({ bankTransactionsDebit: bankTransactionsDebit, openAddNewTransaction: false });
        }
        else {
            let bankTransactionsCredit = [...this.state.bankTransactionsCredit];
            let newTransaction = {
                //CHEQUE_NO: this.state.addNewTrasnsactionChequeNumber,
                CR: this.state.addNewTransactionAmount,
                IS_CHEQUE_NOT_PRESENT: 0,
                state: 'realized',
                isNewTransaction: true,
                newTransactionInfo: {
                    ledgerAccountId: this.state.ledgerAccountName,
                    transactionDate: this.state.addNewTransactionDate,
                    transactionNo: this.state.addNewTransactionTransactionNo,
                    description: this.state.addNewTransactionDescription,
                }
            };
            bankTransactionsCredit.push(newTransaction);
            this.setState({ bankTransactionsCredit: bankTransactionsCredit, openAddNewTransaction: false });
        }
    }

    handleAddNewTransactionClose() {
        this.setState({ openAddNewTransaction: false });
    }

    handleAddNewTransactionClick() {
        this.setState(
            {
                addNewTransactionType: 'deposit',
                ledgerAccountRefNo: '',
                ledgerAccountName: '',
                addNewTransactionTransactionNo: '',
                addNewTransactionAmount: '',
                addNewTransactionDescription: '',
                addNewTransactionDate: moment(new Date()).format("YYYY-MM-DD"),
                openAddNewTransaction: true
            }
        );
    }

    handleAddNewTransactionClear() {
        this.setState(
            {
                addNewTransactionType: 'deposit',
                ledgerAccountRefNo: '',
                ledgerAccountName: '',
                addNewTransactionTransactionNo: '',
                addNewTransactionAmount: '',
                addNewTransactionDescription: '',
                addNewTransactionDate: moment(new Date()).format("YYYY-MM-DD"),
                addNewTrasnsactionChequeNumber : '',
                addNewTransactionTransactionDescription : ''
            }
        );
    }

    handleRadioChange = event => {
        this.setState({ addNewTransactionType: event.target.value })
    };

    handleRecordLedgerAccRefChange = selectedOption => {
        console.log('selectedOption', selectedOption);
        var ledgerAccountName = '';
        var ledgerAccountRefNo = '';
        if (selectedOption) {
            ledgerAccountName = selectedOption.value;
            ledgerAccountRefNo = selectedOption.value;
        }
        else {
            ledgerAccountName = '';
            ledgerAccountRefNo = '';
        }
        this.setState(
            {
                ledgerAccountName: ledgerAccountName,
                ledgerAccountRefNo: ledgerAccountRefNo
            }
        );
    }

    handleSave() {
        /* if(parseFloat(this.state.statementBalance).toFixed(2)!=
            (parseFloat(this.getTotalOfTransactionsDebit('realized','debit')) - parseFloat(this.getTotalOfTransactionsCredit('realized','credit'))).toFixed(2)){
                return this.props.alert.error('Please balance the sheet');
        } */
        this.setState({ loading: true });

        //getting should update deposits
        var updatableDepositsRaw = [];
        var newDepositsRaw = [];
        this.state.bankTransactionsDebit.map((item, index) => {
            console.log('item', item);
            console.log('index', index);

            if (this.state.bankTransactionsDebit[index].isNewTransaction) {
                newDepositsRaw.push(item);
            }
            else if (this.state.bankTransactionsDebit[index].state == 'realized' &&
                (this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "1" || this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "-1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: 0 };
                updatableDepositsRaw.push(copyItem);
            }
            else if (this.state.bankTransactionsDebit[index].state == 'return' &&
                (this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "0" || this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: -1 };
                updatableDepositsRaw.push(copyItem);
            }
            else if (this.state.bankTransactionsDebit[index].state == 'not present' &&
                (this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "0" || this.state.bankTransactionsDebit[index].IS_CHEQUE_NOT_PRESENT == "-1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: 1 };
                updatableDepositsRaw.push(copyItem);
            }

        });

        //getting should update payments
        var updatablePaymentsRaw = [];
        var newPaymentsRaw = [];
        this.state.bankTransactionsCredit.map((item, index) => {
            console.log('item', item);
            console.log('index', index);

            if (this.state.bankTransactionsCredit[index].isNewTransaction) {
                newPaymentsRaw.push(item);
            }
            else if (this.state.bankTransactionsCredit[index].state == 'realized' &&
                (this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "1" || this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "-1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: 0 };
                updatablePaymentsRaw.push(copyItem);
            }
            else if (this.state.bankTransactionsCredit[index].state == 'return' &&
                (this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "0" || this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: -1 };
                updatablePaymentsRaw.push(copyItem);
            }
            else if (this.state.bankTransactionsCredit[index].state == 'not present' &&
                (this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "0" || this.state.bankTransactionsCredit[index].IS_CHEQUE_NOT_PRESENT == "-1")) {
                let copyItem = { ...item, IS_CHEQUE_NOT_PRESENT: 1 };
                updatablePaymentsRaw.push(copyItem);
            }

        });

        console.log('updatableDepositsRaw', updatableDepositsRaw);
        console.log('newDepositsRaw', newDepositsRaw);
        console.log('updatablePaymentsRaw', updatablePaymentsRaw);
        console.log('newPaymentsRaw', newPaymentsRaw);

        var updatableDeposits = [];
        var updatablePayments = [];
        var newTransactions = {
            transactionLedgerHeader: {
                TANSACTION_TYPE: 'BANKRECONCILATION',
                DATE: moment(new Date()).format("YYYY-MM-DD"),
                IS_ACTIVE: 1
            },
            transactionLedgerDetails: []
        };

        updatableDepositsRaw.map((item) => {
            updatableDeposits.push({ ID_DIPOSIT_DETAIL_HEADER: item.ID_DIPOSIT_DETAIL_HEADER, IS_CHEQUE_NOT_PRESENT: item.IS_CHEQUE_NOT_PRESENT });
        });
        updatablePaymentsRaw.map((item) => {
            updatablePayments.push({ ID_PAYMENT_MODE: item.ID_PAYMENT_MODE, IS_CHEQUE_NOT_PRESENT: item.IS_CHEQUE_NOT_PRESENT });
        });
        newDepositsRaw.map((item) => {
            let pushItem = [item.newTransactionInfo.ledgerAccountId,null, 'Bank Reconciliation Deposit', null, item.AMOUNT, null, null, 1, null];
            let pushItem2 = [window.CASH_BOOK_LEDGER_ID,null, 'Bank Reconciliation Deposit Double', item.AMOUNT, null, null, null, 1, null];
            newTransactions.transactionLedgerDetails.push(pushItem);
            newTransactions.transactionLedgerDetails.push(pushItem2);
        });
        newPaymentsRaw.map((item) => {
            let pushItem = [item.newTransactionInfo.ledgerAccountId,null, 'Bank Reconciliation Payment', item.CR, null, null, null, 1, null];
            let pushItem2 = [window.CASH_BOOK_LEDGER_ID,null, 'Bank Reconciliation Deposit Double', null, item.CR, null, null, 1, null];
            newTransactions.transactionLedgerDetails.push(pushItem);
            newTransactions.transactionLedgerDetails.push(pushItem2);
        });

        const url = window.accountServer + '/bankReconciliation/saveBankReconciliation';
        const body = {
            updatableDeposits: updatableDeposits,
            updatablePayments: updatablePayments,
            newTransactions: newTransactions
        };
        console.log('bank reconciliation save body', body);
        var request = axios.post(url, body);
        request.then((response) => {
            if (response.data && response.data.success) {
                this.handleClear();
                console.log('Saved', response);
                this.setState({ loading: false });
                this.props.alert.success('Saved');
            }
            else {
                console.log('Save failed', response);
                this.setState({ loading: false });
                this.props.alert.error('Save failed');
            }
        })
            .catch((error) => {
                this.props.alert.error('Save failed');
                this.setState({ loading: false });
                console.log('Save error', error);
            });

    }

    handleClear() {
        this.setState({
            bankTransactionsDebitOriginal: [],
            bankTransactionsCreditOriginal: [],
            bankTransactionsDebit: [],
            bankTransactionsCredit: [],
            statementBalance: 0.00,
            bankLedgerAccountIds: [],
            bankLedgerAccount: '',
            bankName: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),
            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            documentNumber: '',
        });
    }

    componentWillMount() { }

    render() {


        const { classes } = this.props;

        var divDisplayStyle = (value, stateC) => {
            if (stateC == value) {
                return { display: 'inline-block', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="px-16">
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin bank-recon-margin">Bank Reconciliation</h2>
                    </div>

                    <div className="px-4">
                        <div className="px-4 inline-block">
                            <TextField
                                id="name"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                label="Date"
                                placeholder=""
                                type="date"
                                value={this.state.date}
                                onChange={this.handleTextBoxChange('date')}
                            />
                        </div>

                        <div className="px-4 inline-block">
                            <TextField className=""
                                id="documentNumber"
                                label="Document Number"
                                className={classes.textField}
                                value={this.state.documentNumber}
                                onChange={this.handleTextBoxChange('documentNumber')}
                            />
                        </div>

                        <div className="px-4 inline-block">
                            <TextField
                                id="name"
                                className="w-full px-4"
                                className={classes.textField}
                                classes={{
                                    input: classes.input
                                }}
                                label="Transaction Date"
                                placeholder=""
                                type="date"
                                value={this.state.transactionDate}
                                onChange={this.handleTextBoxChange('transactionDate')}
                            />
                        </div>

                        <div className="px-4 inline-block">
                            <TextField className=""
                                id="referenceNo"
                                label="Reference Number"
                                className={classes.textField}
                                value={this.state.referenceNo}
                                onChange={this.handleTextBoxChange('referenceNo')}
                            />
                        </div>
                    </div>

                    <div className=" block bank-recon-second-section">
                        <Select
                            className="inline-block w-1/5"
                            name="form-field-name"
                            placeholder="Select Bank"
                            value={this.state.bankName}
                            onChange={this.handleBankChange}
                            options={this.state.bankList}
                        />

                        <Select 
                            className="inline-block w-1/5 bank-recon-form-margin"
                            name="form-field-name"
                            placeholder="Select Ledger Account"
                            value={this.state.bankLedgerAccount}
                            onChange={this.handleBankLedgerAccountChange}
                            options={this.getBankLedgersByBank()}
                        />

                           <div className="px-4 inline-block bank-recon-form-margin">
                        <TextField
                            id="name"
                            className="inline-block w-1/5 mt-8 bank-recon-form-margin"
                            className={classes.textField}
                            classes={{
                                input: classes.input
                            }}
                            label="From Date"
                            placeholder=""
                            type="date"
                            value={this.state.fromDate}
                            onChange={this.handleTextBoxChange('fromDate')}
                        />
                        </div>

                        <TextField
                            id="name"
                            className="inline-block w-1/5 bank-recon-form-margin"
                            className={classes.textField}
                            classes={{
                                input: classes.input
                            }}
                            label="To Date"
                            placeholder=""
                            type="date"
                            value={this.state.toDate}
                            onChange={this.handleTextBoxChange('toDate')}
                        />

                        <Button
                            variant="raised"
                            color="secondary"
                            className="inline-block w-1/5 bank-recon-btn-width bank-recon-form-margin"
                            onClick={
                                (ev) => {
                                    ev.stopPropagation();
                                    this.handleSearchClick();
                                }
                            }
                        >
                            Search
                            </Button>
                    </div>

                    <div className="p-8">
                        <div className="px-4 inline-block">
                            <TextField className=""
                                id="statementBalance"
                                label="Statement Balance"
                                className={classes.textField}
                                value={this.state.statementBalance}
                                onChange={this.handleFloatTextBoxChange('statementBalance')}
                            />
                        </div>

                        <div className="px-4 inline-block">
                            <TextField className=""
                                id="variance"
                                label="Variance"
                                className={classes.textField}
                                value={(parseFloat(this.getTotalOfTransactionsDebit('realized', 'debit')) - parseFloat(this.getTotalOfTransactionsCredit('realized', 'credit'))).toFixed(2)}
                            />
                        </div>

                        <div className="px-4 inline-block ">
                            {parseFloat(this.state.statementBalance).toFixed(2) ==
                                (parseFloat(this.getTotalOfTransactionsDebit('realized', 'debit')) - parseFloat(this.getTotalOfTransactionsCredit('realized', 'credit'))).toFixed(2)
                                ?
                                <div className="bg-green-lighter">Balanced</div>
                                :
                                <div className="bg-red-lighter">Not Balanced</div>

                                }
                        </div>

                        <div className="px-4">
                            <Button
                                variant="raised"
                                color="secondary"
                                className="mx-auto mt-16"
                                onClick={
                                    (ev) => {
                                        ev.stopPropagation();
                                        this.handleAddNewTransactionClick();
                                    }
                                }
                            >
                                Add New Transaction
                            </Button>
                        </div>
                    </div>

                    <div className="p-8 w-1/2 inline-block">
                        <h3>Deposited</h3>
                        <ReactTable
                            data={this.state.bankTransactionsDebit}
                            columns={[

                                {
                                    Header: "Cheque",
                                    accessor: "CHEQUE_NO",
                                    // filterable : true,
                                    Footer: (
                                        <span>
                                            <strong>Total:</strong>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Amount",
                                    accessor: "AMOUNT",
                                    filterable: true,
                                    Cell: row => (
                                        <div align="right" className="w-full">
                                            {parseFloat(row.original.AMOUNT).toFixed(2)}
                                        </div>
                                    )
                                },
                                {
                                    Header: "Realized",
                                    width: 70,
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'realized')}
                                                onChange={this.handleCheckBoxChangeDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'realized')}
                                            //value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsDebit('realized', 'debit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Return",
                                    width: 70,
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'return')}
                                                onChange={this.handleCheckBoxChangeDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'return')}
                                                value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsDebit('return', 'debit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Not Present",
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'not present')}
                                                onChange={this.handleCheckBoxChangeDebit(row.original.ID_DIPOSIT_DETAIL_HEADER, 'not present')}
                                                value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsDebit('not present', 'debit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Description",
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            {(row.original.newTransactionInfo && row.original.newTransactionInfo.description) ? row.original.newTransactionInfo.description : ''}
                                        </div>
                                    ),
                                }
                                // {
                                //     Header: "",
                                //     Cell: row => (

                                //         <div align="center" className="w-full">
                                //             {(row.original.newTransactionInfo && row.original.newTransactionInfo.description) ? row.original.newTransactionInfo.description : ''}
                                //         </div>
                                //     ),
                                // }
                            ]}
                            //pageSize={this.state.records.length>3?this.state.records.length:3}
                            defaultPageSize={5}
                            className="-striped -highlight"
                        />

                    </div>
                    <div className="p-8 w-1/2 inline-block">
                        <h3>Released</h3>
                        <ReactTable
                            data={this.state.bankTransactionsCredit}
                            columns={[

                                {
                                    Header: "Cheque",
                                    accessor: "CHEQUE_NO",
                                    filterable: true,
                                    Footer: (
                                        <span>
                                            <strong>Total:</strong>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Amount",
                                    accessor: "CR",
                                    filterable: true,
                                    Cell: row => (
                                        <div align="right" className="w-full">
                                            {parseFloat(row.original.CR).toFixed(2)}
                                        </div>
                                    )
                                },
                                {
                                    Header: "Realized",
                                    width: 70,
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueCredit(row.original.ID_PAYMENT_MODE, 'realized')}
                                                onChange={this.handleCheckBoxChangeCredit(row.original.ID_PAYMENT_MODE, 'realized')}
                                            //value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsCredit('realized', 'credit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Return",
                                    width: 70,
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueCredit(row.original.ID_PAYMENT_MODE, 'return')}
                                                onChange={this.handleCheckBoxChangeCredit(row.original.ID_PAYMENT_MODE, 'return')}
                                                value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsCredit('return', 'credit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                },
                                {
                                    Header: "Not Present",
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            <Checkbox
                                                className="brcheckbox"
                                                checked={this.getCheckBoxValueCredit(row.original.ID_PAYMENT_MODE, 'not present')}
                                                onChange={this.handleCheckBoxChangeCredit(row.original.ID_PAYMENT_MODE, 'not present')}
                                                value="checkedA"
                                            />
                                        </div>
                                    ),
                                    Footer: (
                                        <span>
                                            <div align="center" className="w-full">
                                                <strong>
                                                    {this.getTotalOfTransactionsCredit('not present', 'credit')}
                                                </strong>
                                            </div>
                                        </span>
                                    )
                                }
                                ,
                                {
                                    Header: "Description",
                                    Cell: row => (
                                        <div align="center" className="w-full">
                                            {(row.original.newTransactionInfo && row.original.newTransactionInfo.description) ? row.original.newTransactionInfo.description : ''}
                                        </div>
                                    ),
                                }
                            ]}
                            //pageSize={this.state.records.length>3?this.state.records.length:3}
                            defaultPageSize={5}
                            className="-striped -highlight"
                        />

                    </div>

                     <DialogActions className="justify-right pl-16">
                        <div className="px-4 inline-block">
                            <Button
                                variant="raised"
                                color="secondary"
                                className="mx-auto mt-16"
                                onClick={
                                    (ev) => {
                                        ev.stopPropagation();
                                        this.handleSave();
                                    }
                                }
                            >
                                Save
                            </Button>
                        </div>

                        <div className="px-4 inline-block">
                            <Button
                                variant="raised"
                                color="primary"
                                className="mx-auto mt-16"
                                onClick={
                                    (ev) => {
                                        ev.stopPropagation();
                                        this.handleClear();
                                    }
                                }
                            >
                                Clear
                            </Button>
                        </div>
                    </DialogActions>



                    <Dialog open={this.state.openAddNewTransaction} onClose={this.handleAddNewTransactionClose} aria-labelledby="form-dialog-title">
                         <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                <Toolbar className="flex w-full">
                                    <Typography className="w-full" variant="subheading" color="inherit">
                                    Add New Transaction
                          </Typography>
                                    <IconButton className="" color="inherit" onClick={this.handleAddNewTransactionClose} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                        <DialogContent>
                            <div className="w-450">

                                <div className="px-4">
                                    <FormControlLabel
                                        control={
                                            <Radio
                                                checked={this.state.addNewTransactionType === 'deposit'}
                                                onChange={this.handleRadioChange}
                                                value="deposit"
                                                name="deposit"
                                                aria-label="A"
                                                color="default"
                                            />
                                        }
                                        label="Deposit"
                                    />
                                </div>

                                <div className="px-4">
                                    <FormControlLabel
                                        control={
                                            <Radio
                                                checked={this.state.addNewTransactionType === 'expences'}
                                                onChange={this.handleRadioChange}
                                                value="expences"
                                                name="expences"
                                                aria-label="A"
                                                color="default"
                                            />
                                        }
                                        label="Expenses"
                                    />
                                </div>

                                <div className="px-4">
                                    <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Ledger Account"
                                        value={this.state.ledgerAccountName}
                                        onChange={this.handleRecordLedgerAccRefChange}
                                        options={this.state.ledgerAccountNames}
                                    />

                                    <Select
                                        className="bank-recon-dropdown-padding"
                                        name="form-field-name"
                                        placeholder="Select Ledger Account"
                                        value={this.state.ledgerAccountRefNo}
                                        onChange={this.handleRecordLedgerAccRefChange}
                                        options={this.state.ledgerAccountRefs}
                                    />
                                </div>

                                {/* <div className="px-4">
                                    <TextField className=""
                                        id="addNewTrasnsactionChequeNumber"
                                        label="Cheque Number"
                                        className={classes.textField}
                                        value={this.state.addNewTrasnsactionChequeNumber}
                                        onChange={this.handleTextBoxChange('addNewTrasnsactionChequeNumber')}
                                    />
                                </div> */}

                                <div className="px-4">
                                    <TextField className=""
                                        id="addNewTransactionAmount"
                                        label="Amount"
                                        className={classes.textField}
                                        value={this.state.addNewTransactionAmount}
                                        onChange={this.handleFloatTextBoxChange('addNewTransactionAmount')}
                                    />
                                </div>

                                <div className="px-4">
                                    <TextField
                                        id="name"
                                        className="w-full px-4"
                                        className={classes.textField}
                                        classes={{
                                            input: classes.input
                                        }}
                                        label="Date"
                                        placeholder=""
                                        type="date"
                                        value={this.state.addNewTransactionDate}
                                        onChange={this.handleTextBoxChange('addNewTransactionDate')}
                                    />
                                </div>

                                <div className="px-4">
                                    <TextField className=""
                                        id="transactionNo"
                                        label="Reciept / Transaction No"
                                        className={classes.textField}
                                        value={this.state.addNewTransactionTransactionNo}
                                        onChange={this.handleTextBoxChange('addNewTransactionTransactionNo')}
                                    />
                                </div>

                                <div className="px-4">
                                    <TextField className=""
                                        id="description"
                                        label="Description"
                                        className={classes.textField}
                                        value={this.state.addNewTransactionTransactionDescription}
                                        onChange={this.handleTextBoxChange('addNewTransactionDescription')}
                                    />
                                </div>

                                <div className="w-full p-20">


                                    <div className="px-4 inline-block">
                                        <Button
                                            variant="raised"
                                            color="secondary"
                                            className="mx-auto mt-16"
                                            onClick={
                                                (ev) => {
                                                    ev.stopPropagation();
                                                    this.handleAddNewTransactionSave();
                                                }
                                            }
                                        >
                                            Save
                                            </Button>
                                    </div>

                                    <div className="px-4 inline-block">
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="mx-auto mt-16"
                                            onClick={
                                                (ev) => {
                                                    ev.stopPropagation();
                                                    this.handleAddNewTransactionClear();
                                                }
                                            }
                                        >
                                            Clear
                                            </Button>
                                    </div>

                                    <div className="px-4 inline-block">
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="mx-auto mt-16"
                                            onClick={
                                                (ev) => {
                                                    ev.stopPropagation();
                                                    this.handleAddNewTransactionClose();
                                                }
                                            }
                                        >
                                            Close
                                            </Button>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
            )


        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(BankReconsilation));


// WEBPACK FOOTER //
// ./src/main/content/accounting/bankReconsilation/BankReconsilation.js